import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "fill-rule": "evenodd" }, [
      _createElementVNode("path", {
        fill: "#fff",
        d: "M640 480H0V0h640z"
      }),
      _createElementVNode("path", {
        fill: "#dc143c",
        d: "M640 480H0V240h640z"
      })
    ], -1)
  ]))]))
}
export default { render: render }